'use client'
import { Box, Heading } from "@chakra-ui/react"
import HeaderComponent from "@/app/[slug]/components/header/page"
import BlogPosts from "@/components/blog/BlogPosts"
import Blog from "./components/Blog"
import BannerComponent from "@/components/footer/banner"
import FooterComponent from "@/components/footer/footer"
import Consent from "@/components/Consent"


const DinamicPosts = (props: any) => {
  const { dataNews, cabecalho, footer, config, menuRodape, categories, tags } = props
  const beforeWrapper = {
    content: "''",
    position: 'absolute',
    left: 0,
    top: 0,
    width: '100%',
    height: '223px',
    background: 'linear-gradient(to bottom, rgba(0, 0, 0, 0.75) 0%, rgba(252, 252, 252, 0) 99%, rgba(255, 255, 255, 0) 100%)',
    transition: '.3s',
    zIndex: 2
  }
  
  return (
    <>
      <Box _before={beforeWrapper}>
        <HeaderComponent cabecalho={cabecalho} />

        <Box minH={220} maxH={460} pos={'relative'}>
          <Box
            w={'full'}
            bgSize={'cover'}
            bgImage={{
              base: 'https://dr7dcgej7t392.cloudfront.net/uploads/topo_mobile_blog_4c19f94986.webp',
              sm: 'https://dr7dcgej7t392.cloudfront.net/uploads/topo_mobile_blog_4c19f94986.webp',
              md: 'https://dr7dcgej7t392.cloudfront.net/uploads/topo_mobile_blog_4c19f94986.webp',
              lg: '/images/bg_slide.jpg',
              xl: '/images/bg_slide.jpg',
              '2xl': '/images/bg_slide.jpg',
            }}
            // filter={'blur(4px)'}
            h={{
              base: 200,
              sm: 200,
              md: 440,
              lg: 440,
              xl: 440,
              '2xl': 440,
            }}
            p={10}
            className="div-header">

          </Box>
        </Box>
        <Blog
          news={dataNews?.data}
          pagination={dataNews?.meta?.pagination}
          categories={categories}
          config={config}
          tags={tags} />
        <BannerComponent data={footer?.NuvemPalavras} />
        <FooterComponent data={footer} config={config?.data?.attributes} menu={menuRodape} />
        <Consent />
      </Box>
    </>
  )
}
export default DinamicPosts
